import React, { Component } from "react";
import { connect } from "react-redux";
import {
  fetchPartiesList,
  fetchDropdownList,
  fetchRelatedParty,
  fetchRoomDropDownListing
} from "../../redux";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./RelatedPartiesList.module.css";
import { Link, Redirect } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Button } from "reactstrap";
import Dropdown from "../../utils/Dropdown.json";
import api from "../../utils/Api";
import moment from "moment";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import {checkIfPermitted} from "../../services/RolePermissionService";
import Permissions from "../../utils/PermissionKeys.json";
import { firstLetterCapital } from "../../utils/CommonUtil";


function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

function format(cell) {
  if (!cell) {
    return "";
  }
  const type = cell;
  const typeCapitalized = type.charAt(0).toUpperCase() + type.slice(1);
  return `${typeCapitalized}`;
}

export class RelatedPartiesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      related_party_id: "",
      isModalOpen: false,
      reasonType: "",
      label: "",
      other: "",
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      lk_related_party_role_id: "",
      successMessage: "",
      errorMessage: "",
      errorField: "",
      contactsList: [],
      isDataFetched: false,
      isModalOpenContact: false,
      isLoading: false,
      redirectToAccessDenied: false,
      isContactModalLoading: false,
      isCaseFileDownloading: false,
    };
    this.toggle = this.toggle.bind(this);
    this.setLoader = this.setLoader.bind(this);
  }

  componentDidMount = async() => {  
    document.title = 'Contacts - TechToMedix';
    this.props.fetchRoomDropDownListing();   
    if(this.props.location && 
      this.props.location.params && 
      this.props.location.params.lk_related_party_role_id ){
        this.setState({
          lk_related_party_role_id: this.props.location.params.lk_related_party_role_id
        },async()=>{
          await this.props.fetchPartiesList(
            this.state.searchKey,
            this.state.sortBy,
            this.state.page,
            this.state.lk_related_party_role_id
          );
          
          if(this.props.partiesListData && 
            this.props.partiesListData.partiesList && 
            this.props.partiesListData.partiesList.relatedPartyData){
            this.setState({
              contactsList: this.props.partiesListData.partiesList.relatedPartyData
            })
          }
        })
      }else{

        await this.props.fetchPartiesList(
          this.state.searchKey,
          this.state.sortBy,
          this.state.page,
          this.state.lk_related_party_role_id
        );
        
        if(this.props.partiesListData && 
          this.props.partiesListData.partiesList && 
          this.props.partiesListData.partiesList.relatedPartyData){
          this.setState({
            contactsList: this.props.partiesListData.partiesList.relatedPartyData
          })
        }
        
    //RolePermissionService.checkIfPermitted();
      }

    setTimeout(() => {
      if (this.props.partiesListData.partiesList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 2000);
  }

  callRelatedPartyListAPI = async() => {
    this.setState({
      contactsList: [],
    },async()=>{
      await this.props.fetchPartiesList(
        this.state.searchKey,
        this.state.sortBy,
        this.state.page,
        this.state.lk_related_party_role_id
      );
      if(!this.props.partiesListData.loading){

        this.setState({
          contactsList: this.props.partiesListData.partiesList.relatedPartyData
        })
        setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
      }, 1000);
     }
    })
  
  }

  selectRole = (event) => {
    this.setState({
      lk_related_party_role_id: event.target.value,
      page: 1,
      isDataFetched: false
    },()=>{
      this.callRelatedPartyListAPI();
    })
  }

  // toggle a modal
  toggle(val) {
    this.setState((prevState) => ({
      related_party_id: val,
      isModalOpen: !prevState.isModalOpen,
      reasonType: "",
      label: "",
      errorField: "",
    }));
  }

  getRoom = (room_id) => {
   const roomDropDownListData =  this.props.roomDropDownListData.roomDropDownList;

   if(roomDropDownListData.length > 0){
    let room = roomDropDownListData.find((item)=>item.room_id === parseInt(room_id) )
    return (room && room.room_name) ? firstLetterCapital(room.room_name): "Not Available";
   }
   return "Not Available";
  }

  actionsFormatter(cell, row) {
    return (
      <div>
       { checkIfPermitted(Permissions.CREATE_CONTACTS) && ( 
       <Link title="Edit Contact" to={{ pathname: `/app/editcontact/${row.related_party_id}` }}>
          <i className="fa fa-pencil-square-o mr-3 relatedpartylist-edit-icon"></i>
        </Link>)}
        <button
          type="button"
          title="View Contact"
          className={style.iconActionBtn}
          onClick={() => this.toggleContactView(row)}
        >
          <i className={`fa fa-eye ${style.contactView}`}></i>
        </button>
        <button
          type="button"
          title="Delete Contact"
          className={`${style.iconActionBtn} action-icons relatedpartylist-add-icon`}
          onClick={() => this.toggle(row)}
        >
          <i className="fa fa-trash"></i>
        </button>
      </div>
    );
  }

  toggleContactView = (val) => {
    this.setState((prevState) => ({
      isModalOpenContact: !prevState.isModalOpenContact,
      isContactModalLoading: true
    }),async()=>{
      if(this.state.isModalOpenContact){
        await this.props.fetchRelatedParty(val.related_party_id);
        this.setState({
          isContactModalLoading: false
        })
      }
    });
  };

  handleSelectChange = (e) => {
    let index = e.nativeEvent.target.selectedIndex;
    let label = e.nativeEvent.target[index].text;
    let value = e.target.value;
    this.setState({ reasonType: value, label: label });
  };

  handleInputChange = (e) => {
    this.setState({ other: e.target.value });
  };

  handleBlurChange = () => {
    if (this.state.reasonType === "Other" && this.state.other !== "") {
      this.setState({ errorField: "" });
    }
  };

  onSubmit = async (e) => {
    e.preventDefault();
     this.setState((prevState) => ({
            errorMessage: "",
            reasonType: "",
            label: "",
          }));
    // get our form data out of state
    const { reasonType, other, label } = this.state;
    if (reasonType === "" || (reasonType === "4" && other === "")) {
      this.setState({
        errorField: "This field is required",
      });
    } else {
      this.setState({ errorField: "" });
      try {
        const response = await api.delete("relatedparty/deletion/request", {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
          },
          data: {
            related_party_id: this.state.related_party_id.related_party_id,
            deletion_reason_id: Number(reasonType),
            deleted_reason: label !== "Other" ? label : other,
          },
        });
        if (response.status === 200) {
          this.setState({
            successMessage: response.data.message,
            isDataFetched: false
          });
          setTimeout(() => {
            this.setState((prevState) => ({
              successMessage: "",
              isModalOpen: !prevState.isModalOpen,
              reasonType: "",
              label: "",
            }));
            this.callRelatedPartyListAPI()             
          }, 2000);
        }
      } catch (error) {
        this.setState({
          errorMessage: error.response.data.message,
        });
        // setTimeout(() => {
        //   this.setState((prevState) => ({
        //     errorMessage: "",
        //     reasonType: "",
        //     label: "",
        //   }));
        // }, 2000);
      }
    }
  };

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callRelatedPartyListAPI();
    });
  };

  onSearchChange = (event) => {
    this.setState({ 
      searchKey: event.target.value, 
      page: 1, 
      isDataFetched: false 
    },()=>{
      this.callRelatedPartyListAPI();
    });
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ 
      page, 
      isDataFetched: false 
    },()=>{
      this.callRelatedPartyListAPI();
    });
   
  };

  typeFormatter(cell) {
    if (!cell) return "";
    else if(cell === "external_practitioner")
    return "External Practitioner";
    
    return cell.charAt(0).toUpperCase() + cell.slice(1);
  }

  checkValidData = (cell) => {
    if (!cell) return "Not Available";
    return cell;
  }

  nameFormatter(cell, row){
    if (!cell && !row.surname) return "Not Available";
    return ((cell ? (cell.charAt(0).toUpperCase() + cell.slice(1)): "") + " " +
    (row.surname ? (row.surname.charAt(0).toUpperCase() + row.surname.slice(1)):""))
  }

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} className="loader-image" />
        </div>
      );
    }
  }

  // api call for download attachment
  downloadAttachment = async (attachment_id, file_name) => {
    this.setState({
      isLoading: true,
    });
    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    try {
      const response = await api.get("attachment/" + attachment_id, {
        headers: headers,
        responseType: "blob",
      });

      if (response.status === 200) {
        this.setState({
          isLoading: false,
          successMessage: "Attachment downloaded successfully",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file_name);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download file", error);
      this.setState({
        isLoading: false,
        errorMessage: "Error in download file",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };

  
  // Download patient file
  onDownloadSubmitFile = async (relatedPartyData) => {
    this.setState({
      isCaseFileDownloading: true,
    });

    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    const payload = {
      patient_id: relatedPartyData.related_party_id,
    };

    try {
      const response = await api.post(
        "appointment/patientfile/download",
        payload,
        {
          headers: headers,
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        this.setState({
          isCaseFileDownloading: false,
          successMessage: "Case file download successfully",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        if(relatedPartyData && relatedPartyData.file_number){
          link.setAttribute("download", `${relatedPartyData.file_number}.pdf`);
        }else{
          link.setAttribute("download", `${relatedPartyData.name} ${relatedPartyData.surname}.pdf`);
        }
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download", error);
      this.setState({
        isCaseFileDownloading: false,
        errorMessage: "Error in download",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };

  render() {
    // Getting system role
    const system_role =
      localStorage.getItem("USER_INFO") &&
      JSON.parse(localStorage.getItem("USER_INFO")).systemRole;

    // getting dropdown list options from redux persist
    const dropdownData = this.props.dropdownListData.dropdownList;

    // Getting deleted reasons
    const deleteReasons =
      dropdownData.deleted_reason &&
      dropdownData.deleted_reason.map((element, index) => (
        <option key={index} value={element.deleted_reason_id}>
          {element.reason}
        </option>
      ));

      // Getting deleted reasons
    const roleOptions =
    dropdownData.lk_related_party_role &&
    dropdownData.lk_related_party_role.map((element, index) => (
      element.lk_related_party_role_id !== 4 && (<option key={index} value={element.lk_related_party_role_id}>
        {element.role_name}
      </option>)
    ));

    // Related party data
    const relatedPartyDetails =
      this.props.relatedPartyData &&
      this.props.relatedPartyData.relatedPartyData.relatedPartyDetails;

    // Bank details data
    const bankDetails =
      this.props.relatedPartyData &&
      this.props.relatedPartyData.relatedPartyData.bankDetails;

    // Bank details data
    const externalPractitioner =
      this.props.relatedPartyData &&
      this.props.relatedPartyData.relatedPartyData.externalPractitioner;

    // Other data
    const otherData =
      this.props.relatedPartyData &&
      this.props.relatedPartyData.relatedPartyData;

    // attachment
    const attachmentData =
      this.props.relatedPartyData &&
      this.props.relatedPartyData.relatedPartyData.attachment;

      //redirecting to access denied page
    if(this.state.redirectToAccessDenied) {
      return <Redirect
          to="/app/access-denied"
          />;
    }

    return (
      <div className={style.relatedPartiesListMainWarapper}>
        <div className="">
          <div className={style.relatedPartiesListMainWarapper}>
            <div className="row">
              <div className={`col-md-4 order-1`}>
                <h3>Contacts List </h3>
              </div>
            
              <div class="col-xl-8 order-3 order-md-2 d-flex flex-wrap  justify-content-start justify-content-md-end RelatedPartiesList_addRoleBtnWrapper__3C9uO">
                <div class="form-group mr-3">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />                  
                  </div>
                {/* <div>
                  <label class="form-control border-0"></label></div> */}
                <div class="form-group mr-3">
                    <select
                      className="form-control"
                      id="lk_related_party_role_id"
                      onChange={this.selectRole}
                      value={this.state.lk_related_party_role_id}
                    >
                      <option value="">All Roles</option>
                    {roleOptions}
                    </select>
                </div>
                {checkIfPermitted(Permissions.CREATE_CONTACTS) && (
                  <Link to="/app/editcontact">
                    <Button color="primary" className={style.addBtn}>
                      <i className="fa fa-plus mr-2"></i>Add Contact
                    </Button>
                  </Link>  
              )}           
                   </div>
            </div>
            <div className="row">
              
            <div className="col-md-12 order-2 order-md-3 intro-text">
                <p>
                All the Contacts created on the system are listed here. 
                The Actions that may be performed on each Contact are; Edit, View and, Delete. 
                Edit opens up previously captured information on the Contact for amendments. 
                View opens up the saved details on the Contact on a separate screen for viewing. 
                Delete pops up a window where the deletion reason can be selected and submitted for approval.
                </p>
              </div>
            </div>
            <div className="row related-parties-list">
              <div className="col-md-12">
                <BootstrapTable
                  bordered={false}
                  remote={true}
                  data={this.state.contactsList}
                  version="4"
                  search={false}
                  pagination
                  fetchInfo={{
                    dataTotalSize: this.props.partiesListData.partiesList.total,
                  }}
                  options={{
                    sortName: this.state.sortName,
                    sortOrder: this.state.sortOrder,
                    onSortChange: this.onSortChange,
                    onSearchChange: this.onSearchChange,
                    sizePerPage: 10,
                    page: this.state.page,
                    onPageChange: this.onPageChange,
                    noDataText: this.setLoader(),
                  }}
                >
                  <TableHeaderColumn
                    dataField="name"
                    isKey
                    width="20%"
                    dataSort={true}
                    dataFormat={(cell, row)=>this.nameFormatter(cell, row)}
                  >
                    Name
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="email"
                    width="25%"
                    dataSort={true}
                  >
                    Email
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="related_party_role"
                    width="13%"
                    dataSort={true}
                  >
                    Role
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="related_party_type"
                    width="13%"
                    dataSort={true}
                    dataFormat={this.typeFormatter}
                  >
                    Type
                  </TableHeaderColumn>
                  {/* <TableHeaderColumn
                    dataField="file_number"
                    width="15%"
                    dataSort={true}
                    dataFormat={this.checkValidData}
                  >
                    File Number
                  </TableHeaderColumn> */}
                  <TableHeaderColumn
                    dataField="created_at"
                    width="16%"
                    dataSort={true}
                    dataFormat={dateFormatter}
                  >
                    Created Date
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="actions"
                    dataFormat={this.actionsFormatter.bind(this)}
                    width="120px"
                  >
                    Actions
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
          </div>

          {/* Open a modal for delete reason */}
          <Modal
            isOpen={this.state.isModalOpen}
            toggle={this.toggle}
            className={style.deleteReason}
            centered
          >
            <ModalHeader
              toggle={this.toggle}
              className={style.deleteReasonHeader}
            >
              Delete Contact
            </ModalHeader>
            <ModalBody>
              <div className={style.deleteReasonHeadingWrapper}>
                <p>
                  {" "}
                  Please confirm whether you want to delete the contact. Also,
                  select the reason for deletion.{" "}
                </p>
              </div>
              <div className={style.deleteReasonFormWrapper}>
                <form onSubmit={this.onSubmit}>
                  <div className="form-group">
                    <select
                      className={`form-control ${style.customFormControl}`}
                      id="reasonType"
                      value={this.state.reasonType}
                      onChange={this.handleSelectChange}
                      name="reasonType"
                    >
                      <option value="">Select Reason</option>
                      {deleteReasons}
                    </select>
                  </div>
                  {this.state.label === "Other" && (
                    <div className="form-group">
                      <textarea
                        className={`form-control ${style.customFormControl}`}
                        id="other"
                        rows="3"
                        name="other"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                      ></textarea>
                    </div>
                  )}
                  <div className={style.error}>{this.state.errorField}</div>
                  <div className={`row ${style.deleteBtnWrapper}`}>
                    <div className="col-lg-12">
                      <div>
                        <button
                          type="submit"
                          disabled={this.state.successMessage}
                          className={`mr-4 ${style.deleteBtn}`}
                        >
                          Delete
                        </button>
                        <button
                          type="button"
                          disabled={this.state.successMessage}
                          className={style.cancelBtn}
                          onClick={this.toggle}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  {(this.state.successMessage || this.state.errorMessage) && (
                  <div className="row">
                    {this.state.successMessage && (<p className={style.successMessage}>
                      {this.state.successMessage}
                    </p>
                    )}
                    {this.state.errorMessage && (<p className={style.errorMessage}>
                      {this.state.errorMessage}
                    </p>)}
                  </div>
                  )}
                </form>
              </div>
            </ModalBody>
          </Modal>

          {/* Open a contact  view */}
          
          <Modal
            isOpen={this.state.isModalOpenContact}
            toggle={this.toggleContactView}
            className="viewProductDetailsModal"
            centered
          >
            {this.state.isContactModalLoading ? (
            <div className={style.loadingWrapper}>
              <img src={ttmLoader} alt="modal-loader" className={style.loading} />
            </div>
          ) : (
          <React.Fragment>
            <ModalHeader
              toggle={this.toggleContactView}
              className={style.deleteModalHeader}
            >
              Contact Details
            </ModalHeader>
            <ModalBody>
              <div className={style.productviewDetailsWrapper}>
                <div className="row">
                  {/* <div className="col-md-12">
                    <h6 className={style.viewHeading}>Contact</h6>
                  </div> */}
                  <div className="col-md-3">
                    <p className="key">Contact Type:</p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      {relatedPartyDetails &&
                        this.typeFormatter(relatedPartyDetails.related_party_type)}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row ">
                  <div className="col-md-12">
                    <h6 className={style.viewHeading}>Individual Info</h6>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Title of the Contact:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails && relatedPartyDetails.role_name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Title:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails && relatedPartyDetails.title}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">First Name:</p>
                      </div>
                      <div className="col-md-6">
                        <p>{relatedPartyDetails && relatedPartyDetails.name}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Last Name:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails && relatedPartyDetails.surname}
                        </p>
                      </div>
                    </div>
                  </div>
                  {relatedPartyDetails && Number(relatedPartyDetails.lk_related_party_role_id) === 11 && (
                  <React.Fragment>
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <p className="key">PCNS Number:</p>
                        </div>
                        <div className="col-md-6">
                          <p>
                            {externalPractitioner && this.checkValidData(externalPractitioner.billing_practise_pcns_number)}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <p className="key">Practice Type:</p>
                        </div>
                        <div className="col-md-6">
                          <p>
                            {externalPractitioner && this.checkValidData(externalPractitioner.discipline_name)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                  )}
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Date Of Birth:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {" "}
                          {relatedPartyDetails && relatedPartyDetails.dob ?
                            moment(relatedPartyDetails.dob).format(
                              "YYYY-MM-DD"
                            ) : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Gender:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails &&
                          relatedPartyDetails.gender
                            ? relatedPartyDetails.gender
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">ID/Passport Number:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails &&
                          relatedPartyDetails.passport_number
                            ? relatedPartyDetails.passport_number
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Physical Address:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails &&
                          relatedPartyDetails.physical_address
                            ? relatedPartyDetails.physical_address
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Postal Address:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails &&
                          relatedPartyDetails.postal_address
                            ? relatedPartyDetails.postal_address
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Cell Phone Number:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails &&
                            relatedPartyDetails.contact_number}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Email Address:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails && relatedPartyDetails.email}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Main Member:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails &&
                          relatedPartyDetails.main_member
                            ? relatedPartyDetails.main_member
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Referring Practitioner:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails &&
                          relatedPartyDetails.referring_practioner
                            ? relatedPartyDetails.referring_practioner
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Communication:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails &&
                            relatedPartyDetails.communication_mode}
                        </p>
                      </div>
                    </div>
                  </div> */}
                  
                  {relatedPartyDetails && Number(relatedPartyDetails.lk_related_party_role_id) === 3 && (
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Room:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {relatedPartyDetails &&
                            this.getRoom(relatedPartyDetails.room_id)}
                        </p>
                      </div>
                    </div>
                  </div>)}
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-12">
                    <h6 className={style.viewHeading}>Other:</h6>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-3">
                        <p className="key">System role:</p>
                      </div>
                      <div className="col-md-3">
                        <p>
                          {relatedPartyDetails &&
                          relatedPartyDetails.system_role
                            ? relatedPartyDetails.system_role
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  {attachmentData && attachmentData.length > 0 && (
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-3">
                        <p className="key">Upload Documents:</p>
                      </div>
                      <div className="col-md-9">
                        {attachmentData &&
                          attachmentData.map((element, index) => (
                            <Link
                              className={style.downloadLink}
                              onClick={() => {
                                this.downloadAttachment(
                                  element.attachment_id,
                                  element.attachment_file_name
                                );
                              }}
                            >
                              <span
                                key={index}
                                className={style.uploadDocsWrapper}
                              >
                                <i class="fa fa-paperclip mr-1"></i>{" "}
                                {element.attachment_file_name}
                              </span>
                            </Link>
                          ))}
                        {attachmentData && attachmentData.length === 0 && (
                          <p>Not uploaded</p>
                        )}
                      </div>
                    </div>
                  </div>)}
                </div>
                <hr />
                {otherData 
                && otherData.isPatientFile && (
                <div className="row">
                  <div className="col-md-12">
                    <h6 className={style.viewHeading}>Patient File</h6>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-12">
                      <span
                                class={style.caseFileWrapper}
                                onClick={()=>this.onDownloadSubmitFile(relatedPartyDetails)}
                              >
                                <i
                                  class={`fa fa-paperclip mr-2 ${style.caseFileIcon}`}
                                ></i>
                                {relatedPartyDetails && 
                                  !relatedPartyDetails.file_number && (
                                  <span> {`${relatedPartyDetails && 
                                  relatedPartyDetails.name} ${relatedPartyDetails && 
                                  relatedPartyDetails.surname}.pdf`} </span>)}

                                  {relatedPartyDetails && 
                                  relatedPartyDetails.file_number &&(
                                  <span> {`${relatedPartyDetails && 
                                  relatedPartyDetails.file_number}.pdf`} </span>)}
                              </span>
                      </div>
                    </div>
                  </div>
                </div>
                )}
                <div className="row">
                  <div className="col-md-12">
                    {(this.state.isLoading || this.state.isCaseFileDownloading)  ? (
                      <div className={style.loadingWrapper}>
                        <img src={ttmLoader} className={style.loading} />
                      </div>
                    ) : (
                      <div>
                        {this.state.successMessage && (
                          <p className={style.successMessage}>
                            {this.state.successMessage}
                          </p>
                        )}
                        {this.state.errorMessage && (
                          <p className={style.errorMessage}>
                            {this.state.errorMessage}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </ModalBody>
              </React.Fragment>
        )}
          </Modal>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    partiesListData: state.relatedPartiesList,
    dropdownListData: state.dropdownList,
    relatedPartyData: state.relatedPartyData,
    roomDropDownListData: state.roomDropDownList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
    fetchPartiesList: (searchKey, sortBy, page, lk_related_party_role_id) =>
      dispatch(fetchPartiesList(searchKey, sortBy, page, lk_related_party_role_id,0)),
    fetchRelatedParty: (relatedParty) =>
      dispatch(fetchRelatedParty(relatedParty)),
      fetchRoomDropDownListing:  () => dispatch(fetchRoomDropDownListing()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RelatedPartiesList);
